export default __webpack_public_path__ + "static/char-21-2e821a2032ba597162db130fa1c91d2e.gif";